import React, { ReactNode } from 'react';

export interface ReportingEmptyStateProps {
  title: string;
  description?: string;
  icon?: ReactNode;
}

const DefaultIcon = () => (
  <svg
      className='h-12 w-12 text-gray-300'
      fill='none'
      stroke='currentColor'
      viewBox='0 0 24 24'
  >
    <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
        d='M9 17v-2a4 4 0 014-4h0a4 4 0 014 4v2M3 21h18M5 21V7a2 2 0 012-2h10a2 2 0 012 2v14'
    />
  </svg>
);

export const ReportingEmptyState: React.FC<ReportingEmptyStateProps> = ({
  title,
  description,
  icon,
}) => (
  <div className='flex flex-col items-center justify-center px-4 py-12 text-center'>
    <div className='mb-3'>{ icon ?? <DefaultIcon /> }</div>
    <h3 className='font-medium text-gray-600'>{ title }</h3>
    { description && (
      <p className='mt-1 max-w-sm text-sm text-gray-400'>{ description }</p>
    ) }
  </div>
);
